// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-list-container {
  padding: 20px;
}

.center-list-container .admin-header {
  margin-bottom: 20px;
}

.center-list-container .admin-filters {
  margin-bottom: 20px;
}

.center-list-container .admin-table-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.center-list-container .error-message {
  padding: 20px;
  text-align: center;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  margin-bottom: 20px;
}

.center-list-container .error-message p {
  color: #ff4d4f;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./pages/CenterList/center-list.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".center-list-container {\r\n  padding: 20px;\r\n}\r\n\r\n.center-list-container .admin-header {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.center-list-container .admin-filters {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.center-list-container .admin-table-container {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.center-list-container .error-message {\r\n  padding: 20px;\r\n  text-align: center;\r\n  background: #fff2f0;\r\n  border: 1px solid #ffccc7;\r\n  border-radius: 4px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.center-list-container .error-message p {\r\n  color: #ff4d4f;\r\n  margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
